(function () {
    'use strict';

    angular
        .module('app.components', [
            'app.core'
        ]);

})();
